import styled from 'styled-components'

import { BaseCell } from '../../DataGrid.styles'
import { COLORS } from '../../DataGrid.theme'

export const ContentCell = styled(BaseCell)<{
  $isEvenRow: boolean
  $isRowSelected?: boolean
  $isInteractive?: boolean
  $spanCount?: number
  $isCellInGroupedRow?: boolean
}>`
  ${({ $isRowSelected, $isEvenRow, $isInteractive, $spanCount, $isCellInGroupedRow, theme }) =>
    `background-color: ${
      $isRowSelected
        ? theme.selectedRowBackground
        : $isEvenRow
          ? theme.evenRowBackground
          : theme.oddRowBackground
    };

    cursor: ${$isInteractive ? 'pointer' : 'normal'};
     ${$spanCount ? `grid-row: span ${$spanCount};` : ''};
     ${$isCellInGroupedRow ? `border-top: 1px solid ${COLORS.neutralMedium};` : ''}

    ${
      $isRowSelected
        ? '&:after { border-top: 1px solid black; border-bottom: 1px solid black; }'
        : ''
    };
    `}
  }
`
